<template lang="pug">
  div.case-compare
</template>

<script>
export default {
  name: 'CaseCompare'
}
</script>

<style lang="scss" scoped>
  .case-compare{}
</style>



// WEBPACK FOOTER //
// src/pages/index/CaseCompare/CaseCompare.vue